import {WalkOfShameParsedData} from "./WalkOfShameParsedData";
import {FeatureBuyData, IMToWildFeature, ISymbolValues, IWalkOfShameInitData} from "./IWalkOfShameData";
import {WalkOfShameDataParser} from "./WalkOfShameDataParser";

export class WalkOfShameParsedInitData extends WalkOfShameParsedData {

    public readonly symbolValues: ISymbolValues;
    public readonly isRestoreState: boolean;
    public readonly featureBuyTimesBetValue: FeatureBuyData[];
    public readonly mToWildFeature: IMToWildFeature[];

    constructor(rawData: IWalkOfShameInitData, parser: WalkOfShameDataParser) {
        super(rawData, parser);

        this.symbolValues = rawData.symbolValues;
        this.isRestoreState = rawData.isRestoreState;
        this.featureBuyTimesBetValue = rawData.featureBuyTimesBetValue;
        this.currentMultiplier = Math.max(1, (rawData.stickyFSMultiplier !== null ? rawData.stickyFSMultiplier : 1));
        this.mToWildFeature = this.prepareMToWildData(rawData.stickyWildSymbol);
    }

    private prepareMToWildData(stickyWildSymbol: string[]): IMToWildFeature[] {
        const retVal: IMToWildFeature[] = [];

        for (let reel: number = 1; reel < stickyWildSymbol.length; reel++) {
            if (stickyWildSymbol[reel]) {
                retVal.push({
                    reel: reel,
                    symbol: stickyWildSymbol[reel]
                });
            }
        }

        return retVal;
    }
}